import { GET_RECENT_JOBS_START, GET_RECENT_JOBS_SUCCESS, GET_RECENT_JOBS_ERROR } from './RecentJobsActions';

const initialState = {
  recentJobs: {
    jobs: [],
    loading: false,
    loaded: true,
    error: null
  }
};

function recentJobsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_RECENT_JOBS_START: {
      return {
        ...state,
        recentJobs: {
          jobs: [],
          loading: true,
          loaded: false,
          error: null
        }
      };
    }
    case GET_RECENT_JOBS_SUCCESS: {
      return {
        ...state,
        recentJobs: {
          jobs: action.jobs,
          loading: false,
          loaded: true,
          error: null
        }
      };
    }
    case GET_RECENT_JOBS_ERROR: {
      return {
        ...state,
        recentJobs: {
          jobs: [],
          loading: false,
          loaded: true,
          error: action.error
        }
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}

export default recentJobsReducer;
